import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getTuinaReservationGrouped } from '@/service/tuina'

export const fetchTuinaReservationGrouped = createAsyncThunk(
  'tuinaReservationGrouped/fetchTuinaReservationGrouped',
  async ({ query = {} } = {}, { rejectWithValue }) => {
    try {
      const response = await getTuinaReservationGrouped(query)
      const rows = Array.isArray(response.data) ? response.data : []
      return {
        data: rows.filter((g) => !g.therapistId || g.status === 'on_duty'),
        query
      }
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.msg ||
          error?.response?.data?.message ||
          error?.msg ||
          error?.message ||
          '加载日看板失败'
      )
    }
  }
)

const reservationGroupedSlice = createSlice({
  name: 'tuinaReservationGrouped',
  initialState: {
    fetching: false,
    error: null,
    query: {},
    data: []
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTuinaReservationGrouped.pending, (state) => {
        state.fetching = true
        state.error = null
      })
      .addCase(fetchTuinaReservationGrouped.fulfilled, (state, action) => {
        state.fetching = false
        state.error = null
        state.query = action.payload.query
        state.data = action.payload.data || []
      })
      .addCase(fetchTuinaReservationGrouped.rejected, (state, action) => {
        state.fetching = false
        state.error = action.payload ?? action.error?.message ?? null
      })
  }
})

export default reservationGroupedSlice.reducer
